import DashboardWidget from "../DashboardWidget";
import PeopleAltOutlinedIcon from '@mui/icons-material/PeopleAltOutlined';
import { useEffect, useState } from "react";
import dashboardServicev2 from "../../service/DashboardServicev2";
import batchParameterv2 from "../../service/BatchParameterv2";
import WidgetPeriodSelection from "./WidgetPeriodSelection";

const CalisanSayisiWidget = () => {

    const [loading, setLoading] = useState(false);
    const [sayi, setSayi] = useState(15248);
    const [periodId, setPeriodId] = useState(null);

    useEffect(() => {
        (async () => {
            try {
                setLoading(true);
                const _periodId = await batchParameterv2.getDonem();
                setLoading(false);
                setPeriodId(_periodId);
            } catch (e) {
                console.error(e);
            }

        })();
    }, []);


    useEffect(() => {
        if (periodId) {
            (async () => {
                try {
                    setLoading(true);
                    const _sayi = await dashboardServicev2.getPersonelSayisi({ periodId });
                    setSayi(_sayi);
                } catch (e) {
                    console.error(e)
                } finally {
                    setLoading(false);
                }
            })();
        }
    }, [periodId]);


    return (
        <DashboardWidget loading={loading}>
            <div style={{ padding: "0 24px", width: "100%", position: "relative" }}>
                <WidgetPeriodSelection periodId={periodId} setPeriodId={setPeriodId} />
                <table style={{ width: "100%" }}>
                    <tbody>
                        <tr>
                            <td style={{ width: 75, verticalAlign: "middle" }}>
                                <div style={{ color: "#7959FB", fontSize: "48px", lineHeight: "56px", paddingRight: 12 }}>
                                    {
                                        sayi[0] ?
                                            new Intl.NumberFormat('tr-TR').format(sayi[0]?.personelSayisi) :
                                            "-"}
                                </div>
                            </td>
                            <td style={{ color: "rgba(0, 0, 0, 0.38)" }}>
                                <div>Securitas Güvenlik Firması</div>
                                <div>{periodId} Döneminde</div>
                                <div>Tüm Şubelerde</div>
                            </td>
                            <td style={{ width: 75 }}>
                                <div style={{
                                    width: "73px",
                                    height: "73px",
                                    background: "#271F71",
                                    borderRadius: "100%",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center"
                                }}>
                                    <PeopleAltOutlinedIcon sx={{ color: "white", fontSize: "38px" }} />
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td />
                            <td>
                                <div style={{ color: "rgba(0, 0, 0, 0.6)", fontSize: "16px", lineHeight: "24px" }}>
                                    Personel Çalışmaktadır
                                </div>
                            </td>
                            <td />
                        </tr>
                    </tbody>
                </table>
            </div>
        </DashboardWidget>
    )

}

export default CalisanSayisiWidget;
